<mat-dialog-content  class="netop-dialog-content" [ngClass]="cssClass">
    <ng-content></ng-content>
</mat-dialog-content>
